// extracted by mini-css-extract-plugin
export default {"main":"Switch_main__ATLFY","disabled":"Switch_disabled__G09lG","cursor":"Switch_cursor__KgZk+","active":"Switch_active__g0MEZ"};